const GOOGLE_ADS_CONVERSION_ID = 'AW-757227513';
const GOOGLE_ADS_CONVERSION_LABEL = 'ttn4CPf_x7obEPm_iekC';
const DEFAULT_SEND_TO = `${GOOGLE_ADS_CONVERSION_ID}/${GOOGLE_ADS_CONVERSION_LABEL}`;

function invokeGtag(eventName, params) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
      return true;
    }
  } catch (err) {
    console.error('Google Ads gtag invocation failed', err);
  }
  return false;
}

/**
 * Fire the Google Ads conversion event, retrying briefly if gtag is still loading.
 * We retry because the cookie banner defers loading the tag until consent.
 */
export function trackGoogleAdsConversion(overrides = {}) {
  if (typeof window === 'undefined') return;

  const params = {
    send_to: DEFAULT_SEND_TO,
    ...overrides
  };

  if (invokeGtag('conversion', params)) return;

  const maxAttempts = 2;
  let attempt = 0;

  const timer = setInterval(() => {
    attempt += 1;
    if (invokeGtag('conversion', params) || attempt >= maxAttempts) {
      clearInterval(timer);
    }
  }, 200);
}

